/**
 * The Foundation's mark and wordmark, from the official logo (2026-09-20).
 *
 * Both are inline SVGs painted with `currentColor`, so a parent sets the
 * colour the way it sets text colour. The wordmark is the logo's own
 * outlined letterforms — "TYLER ROBINSON" over "FOUNDATION", all capitals,
 * in the Foundation's typeface — which is why there is no font-family here:
 * the face ships as geometry, exactly as the Foundation draws it.
 */
import { TRF_BIRD_PATH, TRF_WORDMARK_PATHS } from './trf-logo-paths';

interface MarkProps {
  /** Rendered height in px; width follows the drawing's proportions. */
  height?: number;
  className?: string;
}

/** The bird alone. */
export function TRFBirdMark({ height = 28, className }: MarkProps) {
  return (
    <svg
      viewBox="2 5 31 34"
      height={height}
      width={height * (31 / 34)}
      className={className}
      aria-hidden
      focusable="false"
    >
      <path d={TRF_BIRD_PATH} fill="currentColor" />
    </svg>
  );
}

/** "TYLER ROBINSON / FOUNDATION" — the outlined wordmark, no bird. */
export function TRFWordmark({ height = 22, className }: MarkProps) {
  return (
    <svg
      viewBox="39 17.8 100 16"
      height={height}
      width={height * (100 / 16)}
      className={className}
      preserveAspectRatio="xMinYMid meet"
      aria-hidden
      focusable="false"
    >
      {TRF_WORDMARK_PATHS.map((d, i) => (
        <path key={i} d={d} fill="currentColor" />
      ))}
    </svg>
  );
}
